module.exports = __webpack_public_path__ + "static/Davos_slogan.ae527489.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Davos_slogan.svg
// module id = 14
// module chunks = 35783957827783 40787343088564 110745335445244 114276838955818